export enum SignCollectStatus {
  unknown = 'unknown',
  // Status
  complete = 'complete',
  failed = 'failed',
  cancelled = 'cancelled',
  // Substatus when status is pending
  usersign = 'usersign',
  outstandingtransaction = 'outstandingtransaction',
  noclient = 'noclient',
  started = 'started',
  processing = 'processing',
}

export class SignCollectStatusHelper {
  public static parse(value: string): SignCollectStatus {
    if (value in SignCollectStatus) {
      return SignCollectStatus[value as keyof typeof SignCollectStatus];
    }
    return SignCollectStatus.unknown;
  }
}
